import { Component, Inject, OnInit } from '@angular/core';
import { EventLoggerService } from '@services/event-logger-service';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { NgClass } from '@angular/common';
import { LockIconComponent } from '@components/lock-icon/lock-icon.component';

@Component({
  selector: 'app-gamification-streak-broken-bottomsheet',
  imports: [
    NgClass,
    LockIconComponent
],
  templateUrl: './gamification-streak-broken-bottomsheet.component.html',
})
export class GamificationStreakBrokenBottomsheetComponent implements OnInit {

  constructor(
    private readonly eventLogger: EventLoggerService,
    private readonly bottomSheetRef: MatBottomSheetRef<GamificationStreakBrokenBottomsheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { onClose?: () => void }
  ) {
  }

  ngOnInit(): void {
    this.eventLogger.cleverTapEvent('impression', JSON.stringify({
        bannerName: `skinStart_streak_broken`,
      })
    );
  }

  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
    if (this.data?.onClose) {
      this.data.onClose();
    }
  }
}
